import client from '@/api/helper/client';
import { Client } from '@nio-fe/liquor-client';
import type { HttpResponseV2 } from '@/api/helper/http.define';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import type { CustomConfig } from '@/api/model/hebeModel';
import Dexie from 'dexie';
import Promise = Dexie.Promise;
import { raw } from '@rsbuild/core/dist-types/loader/transformRawLoader';

// 后端约定 frequently_used_app类型 第一个永远占用
export const setCustomConfig = function (params: CustomConfig) {
  return client.post<HttpResponseV2<CustomConfig>>('/hebe/v1/config', params);
};

// https://apidoc.nioint.com/project/7443/interface/api/831418
export const getCustomConfig = function (params: {
  types: string;
  module: string;
  domain_account: string;
}) {
  return client.get<HttpResponseV2<CustomConfig>>(`/hebe/v1/config`, params);
};

export class HebeClient extends Client {
  constructor() {
    super('/hebe');
  }

  setCustomConfig(params: CustomConfig, brand = 'nio') {
    return this.get('/v1/config', params, {
      headers: {
        'X-Request-Brand': brand,
      },
    });
  }
  getCustomConfig(
    params: {
      types: string;
      module: string;
      domain_account: string;
    },
    brand = 'nio'
  ) {
    return this.get(`/v1/config`, params, {
      headers: {
        'X-Request-Brand': brand,
      },
    });
  }

  fetchCouponList(accountId, brand = 'nio') {
    return this.get(
      `/v1/user-equity/${accountId}/coupon/list`,
      {},
      {
        headers: {
          'X-Request-Brand': brand,
        },
      }
    );
  }

  fetchEquityInfo(accountId, brand = 'nio') {
    return this.get(
      `/v1/user-equity/${accountId}/info`,
      {},
      {
        headers: {
          'X-Request-Brand': brand,
        },
      }
    );
  }

  createCouponTransLink(
    from: any,
    { issueId, message, receiverAccountId, channel = 'im' },
    brand = 'nio'
  ) {
    return this.post(
      `/v1/user-equity/${from}/coupon/transfer`,
      {
        couponIssueId: issueId,
        channel: 'im',
        message,
        receiverAccountId,
      },
      {
        headers: {
          'X-Request-Brand': brand,
        },
      }
    );
  }

  /**
   * https://apidoc.nioint.com/project/7443/interface/api/1354693
   * @param {string[]} brandList
   * @returns {Promise<any>}
   */
  registerBind(brandList: string[]) {
    return this.post('/v1/brand/register-bind', { brandList });
  }

  /**
   * https://apidoc.nioint.com/project/7443/interface/api/1439676
   */
  registerAction(
    brandActionList: { brand: string; actions: string; accountId?: string }[]
  ) {
    return this.post('/v2/brand/action', { brandActionList });
  }

  /**
   * https://apidoc.nioint.com/project/7443/interface/api/1332708
   */
  queryBrandBind() {
    return this.get('/v2/brand/sso/bind/query');
  }
}
